














































































import moment from 'moment';

import { IEmployee, EmployeeType } from '@/models';

import Functions from '@/mixins/functions';
import mixins from '@/utils/mixins';
import CountryFlag from 'vue-country-flag';

import {
  EmployeeFilterParams,
  IEmployeeFetchActionPayload
} from '@/store/employee';
import { PropType } from 'vue';

export default mixins(Functions).extend({
  name: 'EmployeeList',
  components: {
    CountryFlag
  },

  props: {
    employees: Array as PropType<IEmployee[]>,
    numEmployees: Number,

    canEdit: Boolean,

    queryParams: Object as PropType<
      IEmployeeFetchActionPayload & EmployeeFilterParams
    >,
    loading: Boolean
  },

  data() {
    return {
      sortBy: 'employee_number',
      sortDesc: true,
      search: '',
      EmployeeType,

      headers: [
        {
          text: '#',
          sortable: false,
          value: 'employee_number',
          width: 100
        },

        { text: 'Employee', sortable: false, value: 'fullName', width: 180 },
        {
          text: 'Supervisor',
          sortable: false,
          value: 'supervisor',
          width: 180
        },
        {
          text: 'Department',
          sortable: false,
          value: 'hr_department',
          width: 200
        },
        { text: 'Type', sortable: false, value: 'type', width: 90 },
        { text: 'Subtype', sortable: false, value: 'subtype', width: 150 },
        { text: 'Hire Date', sortable: false, value: 'hire_date', width: 120 },
        {
          text: 'Country',
          sortable: false,
          value: 'location',
          width: 50,
          align: 'right'
        },
        {
          text: '',
          sortable: false,
          value: 'actions',
          align: 'center',
          width: 70
        }
      ]
    };
  },

  computed: {
    params: {
      get(): IEmployeeFetchActionPayload & EmployeeFilterParams {
        return this.queryParams;
      },
      set(value: boolean) {
        this.$emit('update:queryParams', value);
      }
    },

    isLoading: {
      get(): boolean {
        return this.loading;
      },
      set(value: boolean) {
        this.$emit('update:loading', value);
      }
    }
  },

  methods: {
    moment,

    openEmployeeDialog(employee?: IEmployee) {
      this.$emit('openEmployeeDialog', employee);
    },

    openEmployeeDeleteDialog(employee: IEmployee) {
      this.$emit('openEmployeeDeleteDialog', employee);
    },

    onUpdatePage(page: number) {
      this.$emit('update:page', page);
    },

    itemClass(item: IEmployee) {
      if (!item.is_active) {
        return 'item--disabled';
      }
    }
  }
});
